import { request } from "../../utils/config"

export const GET_EMAIL_SETTINGS = async () => {
  const response = await request({
    url: `EmailSettings/GetEmailSettings`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const SAVE_EMAIL_SETTINGS = async (data: {
  smtpHost: string
  smtpPort: number
  smtpUser?: string
  smtpPassword?: string
  senderEmail: string
  senderName?: string
  enableSsl: boolean
}) => {
  const response = await request({
    url: `EmailSettings/SaveEmailSettings`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const SEND_TEST_EMAIL = async (data: { toEmail: string; subject?: string; body?: string }) => {
  const response = await request({
    url: `EmailSettings/SendTestEmail`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const BACKUP_AND_SEND_EMAIL = async (data: { targetEmail?: string }) => {
  const response = await request({
    url: `Helpers/BackupAndSendEmail`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
